import Carousel from "react-multi-carousel";
import { colThree } from "../../data/dummyData";

const PremiumBrands = ({ brandList }) => {
  if (!brandList || brandList.length === 0) return null;
  return (
    <div className="brand pt-10 overflow-hidden">
      <div className="container container-lg">
        <div className="brand-inner bg-color-one p-20 rounded-16">
          <div className="section-heading mb-5">
            <div className="flex-between flex-wrap gap-8">
              <h5 className="mb-0 wow bounceInLeft">Top Brands</h5>
              <div className="flex-align gap-16 wow bounceInRight">
                <div className="flex-align gap-8">
                  <button
                    type="button"
                    id="brand-prev"
                    className="slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1">
                    <i className="ph ph-caret-left"></i>
                  </button>
                  <button
                    type="button"
                    id="brand-next"
                    className="slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1">
                    <i className="ph ph-caret-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="brand-slider arrow-style-two">
            <Carousel
              swipeable={false}
              draggable={false}
              showDots={false}
              responsive={colThree}
              ssr={true}
              autoPlay={false}
              autoPlaySpeed={5000}
              keyBoardControl={true}
              customTransition="all .5"
              transitionDuration={500}
              containerClass="carousel-container"
              removeArrowOnDeviceType={["tablet", "mobile"]}
              deviceType="desktop"
              dotListClass="custom-dot-list-style"
              itemClass="carousel-item-padding-40-px">
              {brandList.map((item, index) => (
                <div className="brand-item" data-aos="zoom-in" key={index}>
                  <img
                    src={item?.image}
                    alt={`Brand ${index}`}
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      width: "auto",
                      height: "auto",
                      objectFit: "contain",
                    }}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremiumBrands;
